export const OPERATIONAL_CONTRACT_TYPES = {
  FEE: 'fee',
  REVENUE_SHARE: 'revenue_share',
  FIXED_MARGIN: 'fixed_margin',
} as const;
export type OPERATIONAL_CONTRACT_TYPES =
  (typeof OPERATIONAL_CONTRACT_TYPES)[keyof typeof OPERATIONAL_CONTRACT_TYPES];
